export default {
  getHead: () => {
    return [{name: '회사명'}, {name: '편성액'}, {name: '지출잔액'},  {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 회사명
        case 1: return func.getContent(value).budget //편성액
        case 2: return func.getContent(value).balance // 지출잔액
        case 3: return func.getCreatedDate(value.created_at) // 작성일 // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
      case '회사명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
      case '편성액': return ['content$body.total.budget*%[:default_skw]%']
      case '지출잔액': return ['content$body.total.balance*%[:default_skw]%']
      case '소속명': return ['content$body.stdInfo.department*%[:default_skw]%']
      case '부서명': return ['content$body.stdInfo.section*%[:default_skw]%']
    }
    return []
  },
}
